import Vue from 'vue'
import store from 'store'
import qs from 'qs'

export default {
    getVoicePresets(rootState, callbacks)  {
        let defaultFailErrorCallback = function ()  {
            store.commit('ALERT_DATA_UPDATED', {
                text: 'La récupération des presets de voix a échoué.',
                type: 'danger'
            });
        };

        Vue.axios.get(rootState.baseUrl + "/common/voice-presets", {headers: rootState.headers}).then((response) => {
            if (callbacks.success)  {
                callbacks.success(response.data.voicePresets);
            }
            return true;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            defaultFailErrorCallback();
            return false;
        });
    }
};